// extracted by mini-css-extract-plugin
module.exports = {"root":"Spinner_root__2clCM","Spin":"Spinner_Spin__3uVIo"};